// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_ht-0";
export var optionCard = "_ht-1";